import { CountryIso, CountryIsoByName } from '@/constants/countries'

export const countryNameToISO = (country = '') => CountryIsoByName[country] || CountryIsoByName[`${country.charAt(0).toUpperCase()}${country.slice(1)}`]
export const countryISOToName = (iso?: CountryIso) => Object.keys(CountryIsoByName)[Object.values(CountryIsoByName).indexOf(iso as CountryIso)]
export const toAlpa2ISO = (countryCode) => countryCode
